import React from "react";
import PrintField from "../../shared/PrintField";
import "./NoticeTransformPartnershipToCompany_TH.css";

// stable component type (capture / print mode comes from PrintModeContext)
const InputField = PrintField;

/**
 * ประกาศแปรสภาพห้างหุ้นส่วนจำกัดเป็นบริษัทจำกัด
 * (อิงจากภาพ) - ใช้ input ฝังในบรรทัดเหมือนฟอร์มเดิม
 */
const NoticeTransformPartnershipToCompany_TH = React.forwardRef((props, ref) => {
  return (
    <div className="inv-page">
      <div className="inv-paper inv-en th-form" ref={ref}>
       

        {/* ชื่อห้างหุ้นส่วน + วันที่ */}
        <div className="th-center-line">
          ห้างหุ้นส่วนจำกัด <InputField className="en-input long" />
        </div>

        <div className="th-center-line th-space-top">
          วันที่ <InputField className="en-input long" />
        </div>

        {/* ย่อหน้า 1 */}
        <p className="th-par th-left">
          ด้วยผู้เป็นหุ้นส่วนในห้างหุ้นส่วนจำกัด <InputField className="en-input long" /> ได้ตกลงยินยอมให้แปรสภาพห้างหุ้นส่วนจำกัด
          <InputField className="en-input long" /> ซึ่งตั้งอยู่เลขที่ <InputField className="en-input xlong" /> เป็นบริษัทจำกัด
          ตามมติที่ได้ตกลงยินยอม ลงวันที่ <InputField className="en-input long" />
        </p>

        {/* ย่อหน้า 2 */}
        <p className="th-par th-left">
          ห้างหุ้นส่วนฯ จึงขอประกาศให้ทราบทั่วกัน หากท่านมีคัดค้านขอให้ส่งคัดค้านไปยังห้างหุ้นส่วนฯ ภายในกำหนด 30 วัน
          นับแต่วันประกาศนี้เป็นต้นไป
        </p>

        {/* ปิดท้าย */}
        <div className="th-sincerely">ขอแสดงความนับถือ</div>

        <div className="th-sign-block">
          ( <InputField className="en-input long" /> )
          <div className="th-role">หุ้นส่วนผู้จัดการ</div>
        </div>
      </div>
    </div>
  );
});

export default NoticeTransformPartnershipToCompany_TH;
